export enum CardTypeEnum {
  /// Analysis Report
  AnalysisReport = 0,

  /// Recommendation
  Recommendation = 1,

  /// Live Videos
  LiveVideo = 2,

  /// Ebook
  Ebook = 3,

  /// Program
  Program = 4,

  /// Course
  Course = 5,

  /// Journey
  Journey = 6,

  /// PracticeExam
  PracticeExam = 7,

  /// MasterClass
  MasterClass = 8,

  /// Event
  Event = 9,
}
